export class Publicacion {
    img: string;
    hashtag: string;
    descripcion: string;
    id_usuario: number;
    id_restaurante: number;
    slug: string;
}
